/** Tutorial videos shown from page header play buttons and empty states. */
export const DASHBOARD_TUTORIAL_VIDEOS = {
  createNotice: {
    path: "/videos/createnotice.webm",
    title: "How to Create a Notice",
  },
  createEvent: {
    path: "/videos/createevent.webm",
    title: "How to Create an Event",
  },
  createCircle: {
    path: "/videos/createcircle.webm",
    title: "How to Create a Circle",
  },
  addUser: {
    path: "/videos/adduser.webm",
    title: "How to Add Users",
  },
} as const;
